// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"17879918","634":"7383da4c"}[chunkId] + ".chunk.js";
};